










































































































































































































































































































































































































import { Component, Prop } from 'vue-property-decorator';
import { SwExtendedVue } from '@libs-uuif/shared/sw-extended-vue';
import UUIFComponent from '@/shared/uuifComponent';
import { required } from 'vuelidate/lib/validators';
import DropdownLight from '@/shared/dropdown-light/dropdown-light.vue';
import { State } from 'vuex-class';
import { RootStoreState } from '@/store';
import { tooltip } from '@sonicwall/unified-ui-framework/src/shared/tooltip-dir';
import { TableColumnConfig, TableEntrySelectingEventData, ColumnSortRequestData,
  SortedColumnInfo, TableEntryExpandingEventData  } from '@libs-uuif/shared/sw-table';
import { TableEntry } from '@sonicwall/unified-ui-framework/src/shared/sw-table';
import { VNode, CreateElement } from 'vue';
import { SwStatusFlag } from '@sonicwall/unified-ui-framework/src/shared/sw-status-flag';
import { ConfirmOptions, confirmService } from '@sonicwall/unified-ui-framework/src/shared/confirm-service';
const invalidActivationKey = ({}, classObject: ActivateServiceDialog) => classObject.errorMessage === '';
const cssPrefix = 'activateService';
@Component({
  components: {
    ...UUIFComponent,
    DropdownLight,
  },
  directives: {
    tooltip,
  },
  validations: {
    casApp: { required },
    activationKey: { required, invalidActivationKey },
    dataCenter: { required },
    emailSecurity: {
      dataCenter: { required },
      autoSenderDomain: { required },
      adminEmail: { required },
      company: { required },
    },
  },
})
export default class ActivateServiceDialog extends SwExtendedVue {
  @Prop()
  showActivateServiceDialog: boolean;
  @State((state: RootStoreState) => state.MswProductsStoreModule.productDetails)
  productDetails: any;
  @Prop()
  service: any;
  @Prop({ required:false })
  msgAccept: string;

  @Prop({ required: true, default: 'NO' })
  override: string;
  messageAccept: string;
  casApp: string = '';
  casOptions: any[] = [];
  errorMessage: string = '';
  isemailenc: boolean = false;
  iscasbapprequired: boolean = false;
  renewWarning: string = '';
  cgmsdeletionwarning: string = '';
  isProvisionLicenseMode: boolean = false;
  provisionLicenseValues: any = {};
  gmsOnPremiseOptions: any[] = [];
  gmsOnPremise: string = '';
  // Email Security
  emailSecurity: {
    dataCenter: string,
    autoSenderDomain: string,
    adminEmail: string;
    company: string;
  } = {
    dataCenter: '',
    autoSenderDomain: '',
    adminEmail: '',
    company: '',
  };
  emailEncryptionDcOptions: any = [];
  emailSecurityErrorMessage: string = '';
  isOveride: string = 'NO';
  // Need DC
  isdcrequired: boolean = false;
  dataCenter: string = '';
  dcOptions: any = [];

  activateTerms: string = '';

  // Upgrade & Renew
  isupdaterenew: boolean = false;
  arrupdaterenewoptions: any = [];
  activationKey: string = '';
  submitted: boolean = false;
  activationKeyForm: boolean = true;
  newService: { serviceName: string, serviceId: string } = { serviceName: '', serviceId: '' };
  upgradeRenewSelectedTableRows: any[] = [];
  sortedColumns: SortedColumnInfo[] = [];
  currentUpgradeRenewaction: string = '';
  tableHeight: number = 87;
  CHILDREN_PADDING: number = 10;
  CHILDREN_ROW_HEIGHT: number = 40;
  DEFAULT_ROW_HEIGHT: number = 35;
  DEFAULT_TABLE_HEADER_HEIGHT = 30;
  MAXIMUM_TABLE_HEIGHT: number = 350;
  initSelected : string[] = [];
  isConfirmFwReboot: boolean = false;
  activateServiceData: any = {};
  rootServiceID: number = 0;
  upgradeRenewTableConfig: TableColumnConfig[] =
    [{
      key: 'expand',
      type: 'expand',
      /* tslint:disable-next-line */
      render: (h: CreateElement, data: { entry: TableEntry, index: number }): VNode => {
        return (
          <div>
              {
                data.entry.childServices.map((value: any) => {
                  //  the isDisplayable flag is used to filter the services.
                  if (value.isDisplayable !== '0') {
                    return (
                      <div style={{ display: 'flex', padding: `${this.CHILDREN_PADDING}px`, height: `${this.CHILDREN_ROW_HEIGHT}px` }}>
                        <div style="flex: 3">
                          <div>{value.ServiceName}</div>
                        </div>
                        <div style="flex: 1">
                          <div>{value.NoOfnodes ? value.NoOfnodes : '--' }</div>
                        </div>
                      </div>
                    );
                  }
                })
              }
          </div>
        ) as VNode;
      },
    }, {
      key: 'selection',
      type: 'selection',
      width: 75,
    }, {
      key: 'UpdateType',
      sorter: true,
      width: 150,
      title: (this.$t('products.options1')
      .toString()),
      /* tslint:disable-next-line */
      render: (h: CreateElement, data: { entry: TableEntry, index: number }): VNode => {
        return (
          <div>
              {
                data.entry.UpdateType ? <div>
                  {
                    data.entry.nsmEssential ? <span style="margin-right:1px;"><SwStatusFlag icon-size={12} name="minor"></SwStatusFlag></span> : null
                  }
                  <span> { data.entry.UpdateType}</span>
                  <span> {data.entry.infoText} </span>
                  </div> :
                  <div> </div>
              }
          </div>
        ) as VNode;
      },
    }, {
      key: 'ServiceName',
      dataKey: 'ServiceName',
      sorter: true,
      width: 200,
      title: (this.$t('products.servicename')
      .toString()),
    }, {
      key: 'NoOfnodes',
      dataKey: 'NoOfnodes',
      sorter: true,
      width: 150,
      title: (this.$t('products.clientlicesnse1')
      .toString()),
    }, {
      key: 'ExpirDate',
      dataKey: 'ExpirDate',
      sorter: true,
      width: 150,
      title: (this.$t('products.expdate1')
      .toString()),
    }];
  isFreeTrial: boolean = false;
  cssPrefix = cssPrefix;
  created() {
    if (this.msgAccept !== '' && this.msgAccept !== undefined) {
      this.messageAccept = this.msgAccept;
    }
    if (this.override) {
      this.isOveride = this.override || 'NO';
    }
    setTimeout(() => {
      const wrapper2 = document.getElementById('activationKeyForService') as HTMLElement;
      if (wrapper2) {
        console.warn(wrapper2.children[0].getElementsByTagName('input'));
        wrapper2.children[0]
          .getElementsByTagName('input')[0]
          .focus();
      }
    },         200);
    console.warn('dialog created');
  }
  closeDialog(flag:boolean = false) {
    this.$emit('closeDialog', flag);
  }
  setActivationKey(activationKey: string) {
    this.activationKey = activationKey;
    this.errorMessage = '';
    this.activationKeyForm = true;
  }
  validateForm() {
    this.submitted = true;
    this.errorMessage = '';
    this.isConfirmFwReboot = true;
    if (this.isemailenc) {
      this.$v!.emailSecurity!.$touch();
      if (this.$v!.emailSecurity!.$invalid) {
        return;
      }
      this.isConfirmFwReboot = false;
    } else if (this.iscasbapprequired) {
      this.$v!.casApp!.$touch();
      if (this.$v!.casApp!.$invalid) {
        return;
      }
      this.isConfirmFwReboot = false;
    } else if (this.activationKeyForm) {
      this.$v!.activationKey!.$touch();
      if (this.$v!.activationKey!.$invalid) {
        return;
      }
      this.isConfirmFwReboot = false;
    } else if (this.isdcrequired && !this.isProvisionLicenseMode) {
      this.$v!.dataCenter!.$touch();
      if (this.$v!.dataCenter!.$invalid) {
        return;
      }
      this.isConfirmFwReboot = false;
    }
    this.activateService();
  }
  setCAS(cas: string) {
    this.casApp = cas;
    this.errorMessage = '';
  }
  setDC(dc: string) {
    this.dataCenter = dc;
    this.errorMessage = '';
  }
  onEntrySelecting(data: TableEntrySelectingEventData) {
    if (data.selecting) {
      this.upgradeRenewSelectedTableRows.push(this.arrupdaterenewoptions[Number(data.entryKey)]);
    } else {
      const arrIndexes = this.upgradeRenewSelectedTableRows.map((item) => { return item._key; });
      const removeIndex = arrIndexes.indexOf(Number(data.entryKey));
      this.upgradeRenewSelectedTableRows.splice(removeIndex, 1);
    }
    this.currentUpgradeRenewaction = this.upgradeRenewSelectedTableRows[0] ? this.upgradeRenewSelectedTableRows[0].UpdateType : '';
  }
  get getTableHight() {
    return this.tableHeight;
  }
  get updateRenewData() {
    const data: TableEntry[] = [];
    const noOfRow = this.arrupdaterenewoptions.length;
    this.arrupdaterenewoptions.forEach((entry: any, index: any) => {
      const newEntry: TableEntry = Object.assign({}, entry);
      newEntry._key = index.toString();
      newEntry._selectable = true;
      newEntry._expandable = newEntry.hasOwnProperty('childServices'); // For Expand icon
      newEntry.nsmEssential = noOfRow === 1 && newEntry.ServiceName.toLowerCase() === 'nsm essential' ? true : false ;
      console.warn(newEntry);
      data.push(newEntry);
    });
    return data;
  }
  getcasApplications() {
    this.submitted = false;
    this.$store.dispatch('MswProductsStoreModule/getCasApplication', { activationKey: this.activationKey })
      .then((res: any) => {
        this.$store.commit('stopLoading');
        this.casOptions = res.content.casbAppList.map((each: any) => {
          return {
            id: each.appValue,
            label: each.appName,
            value: each.appValue,
          };
        });
      });
  }
  activateService() {
    this.emailSecurityErrorMessage = '';
    this.errorMessage = '';
    if (this.isupdaterenew && this.currentUpgradeRenewaction === '') {
      this.errorMessage = (this.$t('products.chooseAction')
      .toString());
      return;
    }
    this.rootServiceID = this.newService.serviceName.length === 0 ? this.service.serviceId : this.newService.serviceId;
    const request = {
      rootServiceID: this.rootServiceID,
      isConfirmFwReboot: this.isConfirmFwReboot,
      username: this.$store.getters.getUserId,
      serialNumber: this.productDetails.serialNumber,
      activationKey: this.activationKey,
      messageAccept: this.messageAccept,
      cscDataCenter: this.dataCenter,
      // tslint:disable-next-line:max-line-length
      actionType: this.currentUpgradeRenewaction === 'Downgrade - ' || this.currentUpgradeRenewaction === 'Upgrade - ' ? 'COTERM' : this.currentUpgradeRenewaction,
      isFreeTrial: this.isFreeTrial,
      autoSendERDomains: this.emailSecurity.autoSenderDomain,
      dataCenterLocationID: this.emailSecurity.dataCenter,
      adminEmail: this.emailSecurity.adminEmail,
      companyName: this.emailSecurity.company,
      casappid: this.casApp,
      sbxDataCenter: '',
      firewallManagementAction: '',
      ztValue: '',
      policyServerurl: '',
      ttServerfqdnurl: '',
      strOnPremSerial: '',
      productgroupId: '',
      isoverRide: this.isOveride || 'NO',
    };
    if (this.isProvisionLicenseMode) {
      request.productgroupId = this.provisionLicenseValues.productgroupId;
      if (this.provisionLicenseValues.firewallManagementAction === '0') {
        request.firewallManagementAction = 'CLOUD';
        request.cscDataCenter = this.provisionLicenseValues.selectedDatacenter;
        request.ztValue = this.provisionLicenseValues.enableZeroTouch ? '1' : '0';
      } else if (this.provisionLicenseValues.firewallManagementAction === '1') {
        request.firewallManagementAction = 'ONPREM';
        // tslint:disable-next-line:max-line-length
        request.policyServerurl = this.provisionLicenseValues.selectedOnpremOption.policyserver ? this.provisionLicenseValues.selectedOnpremOption.policyserver : '';
        // tslint:disable-next-line:max-line-length
        request.ttServerfqdnurl = this.provisionLicenseValues.selectedOnpremOption.ttserverfqdn ? this.provisionLicenseValues.selectedOnpremOption.ttserverfqdn : '';
        // tslint:disable-next-line:max-line-length
        request.strOnPremSerial = this.provisionLicenseValues.selectedOnpremOption.serialnumber ? this.provisionLicenseValues.selectedOnpremOption.serialnumber : '';
        request.ztValue = this.provisionLicenseValues.enableZeroTouch ? '1' : '0';
      } else {
        request.firewallManagementAction = 'ONBOX';
        request.ztValue = '';
      }
    }
    if (request.rootServiceID === 6520 ||
        request.rootServiceID === 6560 ||
        request.rootServiceID === 6730 ||
        request.rootServiceID === 6755 ||
        request.rootServiceID === 6745) {
      request.sbxDataCenter = request.cscDataCenter;
      request.cscDataCenter = '';
    }
    this.$store.dispatch('MswProductsStoreModule/activateService', request)
      .then((res: any) => {
        this.$store.commit('stopLoading');
        if (res.operationStatus === 'NOK' && res.msgCode === 'MSWAPP:SWITCHTOCLOUDWARNING') {
          if (res.content.isShowReboot) {
            confirmService.confirm({
              status: 'major',
              title: this.$t('products.firewallRebootNotice').toString(),
              buttons: [{
                key: 'cancel',
                name: this.$t('common.cancel').toString(),
              },
              {
                key: 'confirm',
                name: this.$t('common.confirm').toString(),
                isDefault: true,
              }],
              message: (h: CreateElement): VNode => { // tslint:disable-line
                return (
                <div>
                <p><strong>{ this.$t('common.important') }</strong>: {res.content.switchtoCloudWarningText1}</p>
                <p>{res.content.switchtoCloudWarningText2}</p>
                </div>
                ) as VNode;
              },
            })
            .then((key: any) => {
              if (key === 'confirm') {
                this.isConfirmFwReboot = true;
                this.activateService();
              }
            });
          }
        } else this.takeActionCorrespondingToMessage(res);
      })
      .finally(() => {
        this.isConfirmFwReboot = false;
      });
  }
  takeActionCorrespondingToMessage(res: any, isFreeTrial?: boolean) {
    if (isFreeTrial) {
      this.isFreeTrial = isFreeTrial;
    }
    this.submitted = true;
    switch (res.msgCode) {
      case'MSWAPP:REDIRECTURI':
        this.$store.dispatch('navigateTo', res.content.redirectURI);
        break;
      case 'MSWAPP:ACTSUCCESS':
      case 'FREETRIALOFFER:ACTIVATED':
      case 'GEN:SVCACTIVATION_INPROGRESS':
        this.$store.commit('enqueueMessage', { infoType: 'success', infoMsg: res.msgDesc });
        // this.$emit('serviceUpdate');
        if (this.isProvisionLicenseMode) this.isProvisionLicenseMode = false;
        if (this.provisionLicenseValues !== null) this.provisionLicenseValues = {};
        if (this.isOveride === 'YES') this.isOveride = 'NO';
        this.closeDialog(true);
        break;
      case 'GEN:INVALIDACTKEY':
        if (res.msgDesc.includes('The Support agreement for this product has expired') || res.msgDesc.includes('Click Submit to continue')) {
          this.messageAccept = 'YES';
          if (res.msgDesc.includes('Your Support expiration date will exceed')) {
            this.currentUpgradeRenewaction = 'RENEW';
          }
          this.errorMessage = res.msgDesc;
        } else {
          this.messageAccept = '';
          if (res.content.confirmMessage && res.content.confirmMessage === 'YES') {
            this.messageAccept = 'YES';
            this.$store.commit('enqueueMessage', { infoType: 'major', infoMsg: res.msgDesc });
          } else {
            this.errorMessage = res.msgDesc;
          }
        }
        break;
      case 'MSWAPP:WRONGSIDCHOOSEN':
        this.errorMessage = res.msgDesc;
        this.newService.serviceName = res.content.actualserviceName;
        this.newService.serviceId = res.content.actualserviceID;
        break;
      case 'MSWAPP:CGMSNOTSUPPORTED':
        this.messageAccept = 'YES';
        this.cgmsdeletionwarning = res.message;
        break;
      case 'MSWAPP:NEEDCASBAPP':
        this.iscasbapprequired = true;
        this.activationKeyForm = false;
        this.casOptions.length === 0 && this.getcasApplications();
        break;
      case 'MSWAPP:DCREQUIRED':
        this.submitted = false;
        this.activationKeyForm = false;
        this.isdcrequired = true;
        this.messageAccept = 'YES';
        if (res && res.content.isCloudService) {
          this.provisionLicenseValues = {};
          this.gmsOnPremiseOptions = [];
          this.provisionLicenseValues = {
            datacenterOptions : res.content.arrDataCenter ? res.content.arrDataCenter : [],
            gmsOnPremiseDetails : res.content.onpremdetails ? res.content.onpremdetails : [],
            productgroupId: res.content.productgroupId ? res.content.productgroupId : '',
            enableZeroTouch: false,
            selectedDatacenter: '',
            selectedOnpremOption: {},
            disableOnPremOption: false,
            firewallManagementAction: '0',
            ttserverfqdn:'',
          };
          if (this.provisionLicenseValues.datacenterOptions && this.provisionLicenseValues.datacenterOptions.length > 0) {
            this.provisionLicenseValues.datacenterOptions.map((option: any) => {
              option.id = option.name;
              option.label = option.description;
              option.value = option.name;
              delete option.name;
              delete option.description;
            });
            // tslint:disable-next-line:max-line-length
            this.provisionLicenseValues.selectedDatacenter = this.provisionLicenseValues.datacenterOptions[0] ? this.provisionLicenseValues.datacenterOptions[0].value : '';
          }
          if (this.provisionLicenseValues.gmsOnPremiseDetails && this.provisionLicenseValues.gmsOnPremiseDetails.length > 0) {
            this.provisionLicenseValues.gmsOnPremiseDetails.forEach((each: any) => {
              this.gmsOnPremiseOptions.push({
                id: each.ttserverfqdn,
                label: each.displayname,
                value: each.ttserverfqdn,
              });
            });
            this.gmsOnPremise = this.gmsOnPremiseOptions[0] ? this.gmsOnPremiseOptions[0].value : '';
            this.provisionLicenseValues.selectedOnpremOption = this.provisionLicenseValues.gmsOnPremiseDetails[0];
            // tslint:disable-next-line:max-line-length
            this.provisionLicenseValues.ttserverfqdn = this.provisionLicenseValues.selectedOnpremOption.ttserverfqdn ? this.provisionLicenseValues.selectedOnpremOption.ttserverfqdn : '';
          } else {
            this.provisionLicenseValues.disableOnPremOption = true;
          }
          this.isProvisionLicenseMode = res.content.isCloudService ? true : false;
        } else {
          this.dcOptions = res.content.arrDataCenter.map((each: any) => {
            return {
              id: each.name,
              label: each.description,
              value: each.name,
            };
          });
          this.dataCenter = this.dcOptions[0].value;
        }
        break;
      case 'MSWAPP:DCREQUIREDFOREMAILENC':
        this.submitted = false;
        this.activationKeyForm = false;
        this.isemailenc = true;
        this.messageAccept = 'YES';
        this.emailEncryptionDcOptions = res.content.arrDataCenter.map((each: any) => {
          return {
            id: each.dmDataCenterLocationID,
            label: each.dataCenterName,
            value: each.dmDataCenterLocationID,
          };
          this.emailSecurity.dataCenter = this.emailEncryptionDcOptions[0].value;
        });
        break;
      case 'MSWAPP:UPGRADERENEWACTIONREQUIRED':
        this.activationKeyForm = false;
        this.messageAccept = 'YES';
        this.isupdaterenew = true;
        this.arrupdaterenewoptions = [];
        if (res.content.arrPostActivation) {
          this.arrupdaterenewoptions = res.content.arrPostActivation;
          if (this.arrupdaterenewoptions.length === 1 && this.arrupdaterenewoptions[0].hasOwnProperty('UpdateType')) {
            if (this.arrupdaterenewoptions[0].UpdateType.toLowerCase() === 'coterm' && this.arrupdaterenewoptions[0].hasOwnProperty('ServiceName')) {
              if (this.arrupdaterenewoptions[0].ServiceName.toLowerCase() === 'nsm advanced') {
                this.arrupdaterenewoptions[0].UpdateType = 'Upgrade - ';
                this.initSelected.push('0');
                this.upgradeRenewSelectedTableRows.push(this.arrupdaterenewoptions[Number(0)]);
                this.currentUpgradeRenewaction = this.upgradeRenewSelectedTableRows[0] ? this.upgradeRenewSelectedTableRows[0].UpdateType : '';
              }
              if (this.arrupdaterenewoptions[0].ServiceName.toLowerCase() === 'nsm essential') {
                this.arrupdaterenewoptions[0].UpdateType = 'Downgrade - ';
                this.initSelected.push('0');
                this.upgradeRenewSelectedTableRows.push(this.arrupdaterenewoptions[Number(0)]);
                this.currentUpgradeRenewaction = this.upgradeRenewSelectedTableRows[0] ? this.upgradeRenewSelectedTableRows[0].UpdateType : '';
              }
            }
          }
          if (this.arrupdaterenewoptions.length > 0) {
            this.tableHeight = (this.arrupdaterenewoptions.length * this.DEFAULT_ROW_HEIGHT) +
              this.DEFAULT_TABLE_HEADER_HEIGHT;
            if (this.tableHeight > this.MAXIMUM_TABLE_HEIGHT) {
              this.tableHeight = this.MAXIMUM_TABLE_HEIGHT;
            }
          }
        }
        this.renewWarning = res.content.arrPostActivation[0].status || '';
        break;
      case 'MSWAPP:ACCEPTTERMSCONDITIONS':
        this.messageAccept = 'YES';
        this.activateTerms = res.content.TermsCondition;
        break;
      case 'MSWAPP:SECONDARYSERIALNUMBERONDIFFERENTTENANT':
        this.secondaryserialnumbertransfer(res);
        break;
      case 'MSWAPP:AUTOSENDDOMAININVALID':
        this.emailSecurityErrorMessage = res.msgDesc;
        break;
      case 'MSWAPP:SYSANALYTICSACTKEY':
        const syslogInputs = {
          arrReplacementTypes : res.arrReplacementTypes,
          arrTradeInSerials : res.arrTradeInSerials,
          serialNumber : this.productDetails.serialNumber,
          activationKey: this.activationKey,
        };
        this.$emit('showSysLog', syslogInputs);
        break;
      case 'MSWAPP:TRADEINREQUIRED':
        this.activateServiceData['content'] = res?.content || {};
        this.activateServiceData['content'].activationKey = this.activationKey || '';
        this.activateServiceData['content'].rootServiceID = this.rootServiceID || '';
        this.activateServiceData['content'].arrTradeInSerials = res?.arrTradeInSerials || [];
        this.closeDialog(true);
        break;
      default:
        this.messageAccept = '';
        if (res.content.confirmMessage && res.content.confirmMessage === 'YES') {
          this.messageAccept = 'YES';
          this.$store.commit('enqueueMessage', { infoType: 'major', infoMsg: res.msgDesc });
        } else {
          this.errorMessage = res.msgDesc;
        }
        // this.$store.commit('enqueueMessage', { infoType: 'failed', infoMsg: res.msgDesc });
    }
  }
  secondaryserialnumbertransfer(res: any) {
    const options: ConfirmOptions = {
      status: 'high',
      title: this.$t('products.productTransferConfirmation')
        .toString(),
      message: res.msgDesc || '',
      buttons: [{
        key: 'save',
        name: 'Ok',
        isDefault: true,
      }, {
        key: 'cancel',
        name: 'Cancel',
        isDefault: false,
      }],
    };
    confirmService.confirm(options)
      .then((value) => {
        if (value === 'save') {
          this.isOveride = 'YES';
          this.activateService();
        } else {
          this.closeDialog(true);
        }
      });
  }
  onRequestSorting(data: ColumnSortRequestData) {
    data.cancel = false;
    const index = this.sortedColumns.findIndex(col => (col.colKey === data.colKey));
    if (index < 0) {
      if (data.cancel) { return; }
      this.sortedColumns.splice(0);
      this.sortedColumns.push({
        colKey: data.colKey,
        ascending: !!data.ascending,
      });
    } else {
      if (data.ascending === undefined) {
        this.sortedColumns[index].ascending = !this.sortedColumns[index].ascending;
        return;
      }
      this.sortedColumns[index].ascending = !!data.ascending;
    }
  }
  expandedEntries: Set<string> = new Set();
  shadowExpandedEntries: string[] = [];
  onEntryExpanding(data: TableEntryExpandingEventData) {
    if (data.expanding) {
      this.expandedEntries.add(data.entryKey);
    } else {
      this.expandedEntries.delete(data.entryKey);
    }
    this.shadowExpandedEntries = Array.from(this.expandedEntries);
    this.arrupdaterenewoptions = this.arrupdaterenewoptions.map((entry: any) => {
      return {
        ...entry,
        _toLoadChildren : false,
      };
    });
    let totalChildServices = 0;
    this.arrupdaterenewoptions = this.arrupdaterenewoptions.map((entry: any) => {
      totalChildServices = totalChildServices + (entry.childServices.length || 0);
      return {
        ...entry,
        _toLoadChildren : entry._key === data.entryKey ? true : false,
      };
    });
    if (data.expanding) {
      if (this.expandedEntries.size > 0) {
        this.tableHeight = this.tableHeight + (totalChildServices * this.CHILDREN_ROW_HEIGHT);
        if (this.tableHeight > this.MAXIMUM_TABLE_HEIGHT) {
          this.tableHeight = this.MAXIMUM_TABLE_HEIGHT;
        }
      }
    } else {
      if (this.arrupdaterenewoptions.length > 0) {
        this.tableHeight = (this.arrupdaterenewoptions.length * this.DEFAULT_ROW_HEIGHT) +
          this.DEFAULT_TABLE_HEADER_HEIGHT;
        if (this.tableHeight > this.MAXIMUM_TABLE_HEIGHT) {
          this.tableHeight = this.MAXIMUM_TABLE_HEIGHT;
        }
      }
    }
  }
  onChangeRadio() {
    if (this.provisionLicenseValues.enableZeroTouch) {
      this.provisionLicenseValues.enableZeroTouch = false;
    }
  }
  get getDynamicWidth() {
    if (this.isupdaterenew) {
      return '45%';
    }
    if (this.isProvisionLicenseMode && this.isdcrequired) {
      return '45%';
    }
    return '50%';
  }
  onChangeOnprem(value: any) {
    this.provisionLicenseValues.selectedOnpremOption = this.provisionLicenseValues.gmsOnPremiseDetails.filter((ele: any) => ele.ttserverfqdn  === value)[0];
    // tslint:disable-next-line:max-line-length
    this.provisionLicenseValues.ttserverfqdn = this.provisionLicenseValues.selectedOnpremOption.ttserverfqdn ? this.provisionLicenseValues.selectedOnpremOption.ttserverfqdn : '';
  }
  beforeDestroy() {
    this.isOveride = 'NO';
  }
}
